import { createAction, props } from '@ngrx/store';
import { Rol, RolForm } from '@core/models'
import { ResponseBadRequest } from '@core/interfaces';

export const ROLE_FIND = createAction('[Role] Find', props<{ id: string }>());
export const ROLE_FIND_ALL = createAction('[Role] Find All', props<{ search?: string; resellerId?: string }>());

export const ROLE_FIND_SUCCESS = createAction('[Role] Find Success', props<{ role: Rol }>());
export const ROLE_FIND_ALL_SUCCESS = createAction('[Role] Find All Success', props<{ roleList: Rol[] }>());

export const ROLE_FAILURE = createAction('[Role] Failure', props<{ error: ResponseBadRequest }>());

export const ROLE_UPDATE_LOADING = createAction('[Role] Update Loading', props<{ loading: boolean }>());
export const ROLE_UPDATE_FORM = createAction('[Role] Update Form', props<{ roleForm: RolForm }>());
export const ROLE_UPDATE_FORM_VALID = createAction('[Role] Update Form Valid', props<{ formValid: boolean }>());
export const ROLE_UPDATE_INMUTABLE = createAction('[Role] Update Inmutable', props<{ inmutable: boolean }>());
export const ROLE_EDIT_MODE = createAction('[Role] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const ROLE_UPDATE_ID = createAction('[Role] Update Id', props<{ roleId: string|null }>());

export const ROLE_CREATE_VIEW = createAction('[Role] Create View');
export const ROLE_UPDATE_VIEW = createAction('[Role] Update View', props<{ roleId: string }>());

export const ROLE_CREATE = createAction('[Role] Create');
export const ROLE_UPDATE = createAction('[Role] Update');
export const ROLE_UPDATE_ENABLED = createAction('[Role] Update Enabled', props<{ id: string, roleForm: RolForm }>());
export const ROLE_REMOVE = createAction('[Role] Remove', props<{ id: string }>());

export const ROLE_CREATE_COMPLETED = createAction('[Role] Create Completed');
export const ROLE_UPDATE_COMPLETED = createAction('[Role] Update Completed');
export const ROLE_REMOVE_COMPLETED = createAction('[Role] Remove Completed');

export const ROLE_RESET = createAction('[Role] Reset');
export const ROLE_RESET_FORM = createAction('[Role] Reset Form');
export const ROLE_RESET_ERROR = createAction('[Role] Reset Error');
export const ROLE_CLEAR_STATE = createAction('[Role] Clear State');